import React from 'react';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {Panel} from 'react-bootstrap';
import {HorizontalBar} from 'react-chartjs-2';


const satisfaction_rate_data = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'], // Sample, overwritten later
  datasets: [
    {
      label: 'My First dataset',
      backgroundColor: 'rgba(255,99,132,0.2)',
      borderColor: 'rgba(255,99,132,1)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(255,99,132,0.4)',
      hoverBorderColor: 'rgba(255,99,132,1)',
      data: [65, 59, 80, 81, 56, 55, 40]
    }
  ]
};


@injectIntl @inject('analyticsStore') @observer
export default class SatisfactionRatePlot extends React.Component{
    render(){
        const {intl, analyticsStore} = this.props;
        satisfaction_rate_data.labels = analyticsStore.satisfactionRateKeys;
        satisfaction_rate_data.datasets[0].data = analyticsStore.satisfactionRateValues;
        satisfaction_rate_data.datasets[0].label = intl.formatMessage({id:'satisfaction_rate_label'});

        return(
            <Panel>
                <h3>{intl.formatMessage({id: 'satisfaction_rate_title' })}</h3>
                <br/> 
                <div className='text-center' style={{height: '280px', overflow: 'auto'}}>
                    <HorizontalBar 
                        data={satisfaction_rate_data}
                        options={
                            {
                                maintainAspectRatio: false, 
                                scales: {
                                   xAxes: [{
                                       ticks: {
                                           min: 0,
                                           max: 100,
                                           callback: function(value) {
                                               return value + "%"
                                           }
                                       },
                                       scaleLabel: {
                                           display: true,
                                           labelString: "Percentage"
                                       }
                                   }]
                                },
                                tooltips: {
                                    callbacks: {
                                        label: function(tooltipItem, data) {
                                            return data.labels[tooltipItem.index] + ': ' + data.datasets[0].data[tooltipItem.index] + '%';
                                        }
                                    }
                                }
                            }
                        }
                    />
                </div>
            </Panel>
        );
    }
};